
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { PiAirplaneTakeoffFill } from "react-icons/pi";
import { PiAirplaneLandingFill } from "react-icons/pi";
import { FaCalendarAlt } from "react-icons/fa";
import { BsFillSuitcase2Fill } from "react-icons/bs";
import Form from "react-bootstrap/Form";
import { FaUser } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { FaGenderless } from "react-icons/fa6";
import { MdOutlineRealEstateAgent } from "react-icons/md";
import { useParams } from 'react-router-dom';
import { FaCity } from "react-icons/fa";
import { addItemToken } from "../../Utility/Api";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { formatDateByMonth, capitalizeFirstLetter } from "../../Utility/AxiosInstance";
import { Actions } from "../../redux/Actions/Actions";
import { endPoints } from "../../Constant/Environment";
import Loader from "../Loader/index";
import { InfinitySpin } from 'react-loader-spinner'

function TravelInformation() {
  const { id } = useParams();
  const dispatch = useDispatch();

  let navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [travelInfoData, setTravelInfoData] = useState({});
  const [isLoading, setIsLoadinig] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const GetTravelInfo = () => {
    setIsLoadinig(true);
    let url = `${endPoints.api.GET_TRAVEL_INFO}${id}`;

    addItemToken(url)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          setTravelInfoData(data);
          setIsLoadinig(false);
        } else {
          // alert(message);
        }
      })
      .catch((err) => {
        if (err.response.data.status == 401) {
          dispatch({
            type: Actions.USERLOGOUT,
          });
          localStorage.clear();
          sessionStorage.clear();
          navigate("/");

        }
      });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    GetTravelInfo();
  }, []);

  console.log(travelInfoData);
  return (
    <>
      <section className="sec-padd middle">
        <Container>
          <Row className=" g-5 dashboard-page justify-content-center">
            <Col md={8}>
              <div className="bgwhite">
                {isLoading ? <>

                  <div className="page_loader"><InfinitySpin
                    visible={true}
                    width="200"
                    color="#4fa94d"
                    ariaLabel="infinity-spin-loading"
                  /></div>
                </>
                  : <>
                    <h3 className="c-heading text-center hdmrgn">
                      Traveler Information
                    </h3>
                    <Form className="mb-5">
                      <Row className="align-items-center justify-content-center gy-3">
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <FaUser />
                            Name
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.travelerInfo?.first_name}</p>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <MdEmail />
                            Email
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.travelerInfo?.email} </p>

                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <FaPhone />
                            Mobile
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.travelerInfo?.mobile}  </p>

                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <FaGenderless />
                            Gender
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{capitalizeFirstLetter(travelInfoData?.[0]?.travelerInfo?.gender)}  </p>

                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <MdOutlineRealEstateAgent />
                            Country
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.travelerInfo?.country_name}  </p>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <MdOutlineRealEstateAgent />
                            State
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.travelerInfo?.state_name}  </p>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <FaCity />
                            city
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.travelerInfo?.city_name}  </p>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <PiAirplaneTakeoffFill />
                            From where*
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.fromWhere}</p>

                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <PiAirplaneLandingFill />
                            To where*
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.toWhere}</p>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <FaCalendarAlt />
                            Flight Date
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{formatDateByMonth(travelInfoData?.[0]?.travel_date)}</p>
                        </div>
                        <div className="col-md-3 col-6">
                          <div className="svgicn mb-3 mb-md-0">
                            <BsFillSuitcase2Fill />
                            Max Parcel Weight
                          </div>
                        </div>
                        <div className="col-md-7 col-6">
                          <p>{travelInfoData?.[0]?.maxWeight} Kg</p>
                        </div>
                      </Row>
                    </Form>
                  </>
                }


              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default TravelInformation;